module.exports = __webpack_public_path__ + "img/market-panorama.100ae7a4.jpg";